<script>
import FormInput from '@/components/mixins/FormInput'
import FormTabMixin from '@/components/mixins/FormTabMixin'

import RestApiCollection from '@/api/RestApiCollection'
import RestApiType from '@/api/RestApiType'
import selectApiClientType from '@/api/SelectApiClientType'

import TextInput from '@/components/form/Inputs/TextInput'
import CheckboxInput from '@/components/form/Inputs/CheckboxInput'
import ConfirmModal from '@/components/confirm/ConfirmModal'

import { mapGetters } from 'vuex'
import mealType from '@/store/type/mealType'
import authType from '@/store/type/authType'
import selectapiType from '@/store/type/selectapiType'

export default {
    components: {
        TextInput,
        CheckboxInput,
        ConfirmModal,
    },

    mixins: [FormInput, FormTabMixin],

    data() {
        return {
            api: RestApiType.MEAL_OPTION_GROUP,
            dialog: false,
        }
    },

    computed: {
        ...mapGetters({
            isRestaurantAdmin: authType.getters.IS_RESTAURANT_ADMIN,
        }),
        hasError() {
            return Boolean(this.errors?.items?.length)
        },
    },

    methods: {
        save() {
            if (!this.model.name) return

            if (this.model.id) {
                RestApiCollection.get(this.api)
                    .update(this.model, this.model.id)
                    .then((res) => {
                        this.success(res)
                    })
            } else {
                RestApiCollection.get(this.api)
                    .create(this.model)
                    .then((res) => {
                        this.success(res)
                    })
            }
        },

        deleteGroup() {
            RestApiCollection.get(this.api)
                .delete(this.model.id)
                .then(() => {
                    this.$store.dispatch(
                        mealType.actions.REFRESH_LIST,
                        this.api
                    )
                    this.$store.dispatch(
                        mealType.mutations.MEAL_OPTION_GROUP,
                        {}
                    )
                    this.$store.dispatch(
                        selectapiType.getActionName(
                            selectApiClientType.MEAL_OPTION_GROUP,
                            selectapiType.actions.REFRESH
                        )
                    )
                })
        },

        success(res) {
            this.$store.dispatch(mealType.actions.REFRESH_LIST, this.api)
            this.$store.dispatch(mealType.mutations.MEAL_OPTION_GROUP, res)
            this.$store.dispatch(
                selectapiType.getActionName(
                    selectApiClientType.MEAL_OPTION_GROUP,
                    selectapiType.actions.REFRESH
                )
            )
            this.$emit('saved')
        },
    },
}
</script>

<template>
    <div class="category-form">
        <form @submit.prevent="save">
            <text-input
                v-model="model.name"
                v-tab-error:mealOptionGroups
                v-validate="'required|space'"
                name="name"
                label="labels.name"
                :error-messages="errors.collect('name')"
                :data-vv-as="$t('labels.name')"
            ></text-input>
            <text-input
                v-model.number="model.maxEachQuantity"
                v-tab-error:mealOptionGroups
                type="number"
                name="maxEachQuantity"
                label="labels.max_each_quantity"
                :error-messages="errors.collect('maxEachQuantity')"
                :data-vv-as="$t('labels.max_each_quantity')"
            ></text-input>
            <text-input
                v-model.number="model.maxQuantity"
                v-tab-error:mealOptionGroups
                type="number"
                name="maxQuantity"
                label="labels.max_quantity"
                :error-messages="errors.collect('maxQuantity')"
                :data-vv-as="$t('labels.max_quantity')"
            ></text-input>
            <text-input
                v-model.number="model.minQuantity"
                v-tab-error:mealOptionGroups
                v-validate="`max_value:${model.maxQuantity}`"
                type="number"
                name="minQuantity"
                label="labels.min_quantity"
                :error-messages="errors.collect('minQuantity')"
                :data-vv-as="$t('labels.min_quantity')"
            ></text-input>
            <text-input
                v-if="!isRestaurantAdmin"
                v-model="model.code"
                v-tab-error:mealOptionGroups
                v-validate="'space'"
                name="code"
                label="labels.code"
                :error-messages="errors.collect('code')"
                :data-vv-as="$t('labels.code')"
            ></text-input>
            <checkbox-input
                v-model="model.isActive"
                v-tab-error:mealOptionGroups
                label="labels.active"
                name="isActive"
            ></checkbox-input>
            <div
                class="d-flex justify-end mt-4"
                :class="{
                    'justify-end': !model.id || isRestaurantAdmin,
                    'justify-space-between': model.id && !isRestaurantAdmin,
                }"
            >
                <div v-if="model.id && !isRestaurantAdmin">
                    <v-btn color="error" class="mr-3" @click="dialog = true">
                        {{ $t('actions.delete') }}
                    </v-btn>
                </div>
                <div>
                    <v-btn
                        variant="secondary"
                        class="mr-3"
                        @click="$emit('cancel')"
                    >
                        {{ $t('actions.cancel') }}
                    </v-btn>
                    <v-btn
                        color="success"
                        type="submit"
                        :disabled="!model.name || hasError"
                    >
                        {{ $t('actions.save') }}
                    </v-btn>
                </div>
            </div>
            <confirm-modal
                v-model="dialog"
                :title="$t('texts.are_you_sure')"
                @onApprove="deleteGroup"
            ></confirm-modal>
        </form>
    </div>
</template>
